// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last Add : 'Removed unused service'
// Modified Date : 23-08-2025
import { makeApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/** ***************** FETCH VOUCHER COUNT START *********************** */

export const getJournalTransactionVoucherCountDetailsService = (addData: any) => {
	const data = {
		GetJournalTransactionVoucherCount: addData,
	};
	const url = `${FIN_API_URL}getVoucherCountBasedForcompany`;
	return makeApiCall(url, data);
};

/** ***************** FETCH VOUCHER COUNT END *********************** */

/** ***************** FETCH PARTICULAR ACCOUNT DETAILS END *********************** */

export const getParticularAccountDetailsService = (addData: any) => {
	const data = {
		particularAccountData: addData,
	};
	const url = `${FIN_API_URL}getParticularAccount`;
	return makeApiCall(url, data);
};
/** ***************** FETCH PARTICULAR ACCOUNT DETAILS END *********************** */

/** ***************** CREATE JOURNAL ENTRY START *********************** */

export const getCreateJournalEntryService = (addData: any) => {
	const data = {
		CreateJournalEntryData: addData,
	};
	const url = `${FIN_API_URL}CreateJournalTranscationEntry`;
	return makeApiCall(url, data);
};
/** ***************** CREATE JOURNAL ENTRY END *********************** */

/** ***************** UPDATE JOURNAL ENTRY START *********************** */

export const getUpdateJournalEntryService = (addData: any) => {
	const data = {
		UpdateJournalTransactionData: addData,
	};
	const url = `${FIN_API_URL}updateJournalTranscationEntry`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE JOURNAL ENTRY END *********************** */
